import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import remarkGfm from "remark-gfm";
import options from "./options";

function MarkdownRenderer({ text }) {
  return (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw, rehypeSanitize, remarkGfm]}
      components={{ ...options }}
    >
      {text}
    </ReactMarkdown>
  );
}

export default MarkdownRenderer;
